<template>
	<div class="data-select" :class="isValid?'valid':'invalid'">
		<label :for="id">{{label}}</label>
		<select type="text"
				class="custom-select mt-2"
				:id="id"
				:value="value || ''"
				@change="onInput"
		>
			<option v-if="showDefaultOption" value="" selected="selected">{{$t('placeholder_choose')}}</option>
			<template v-for="opt in options">
				<slot name="default" :option="opt"/>
			</template>
		</select>
	</div>
</template>
<script>
	import uuid from 'uuid'

	export default {
		name: "SlotBasedSelect",
		props: {
			label: String,
			maxValue: {
				type: Number,
			},
			value: String | Number,
			options: Array,
			unit: String
		},
		data() {
			return {
				id: 'id_' + uuid.v1(),
				isValid: true
			}
		},
		computed: {
			showDefaultOption() {
				if (!this.options) {
					return true
				}
				return this.options.indexOf(this.value) === -1
			}
		},
		methods: {
			emitInputEvent(event) {
				console.log('emit input: ', event.target.value)
				console.warn('!!!!emit input: ', event.target.value)
				this.$emit('input', event.target.value)
			},
			onInput(e) {
				this.$emit('input', e.target.value);
				this.isValid = e.target.validity.valid;
			}
		}
	}
</script>
